module.exports = __webpack_public_path__ + "main/Components/HomePage/product_mockup.38029ca29dede5b744e93c45e882ab8d.png";